/**
 * Copyright © 2026 Adnuntius AS.
 *
 * Dependencies used by feature-state resolve factories. The instance belongs
 * to the router helper that builds those states; no module-global injector is
 * retained.
 */
import {Injector, Type} from '@angular/core';
import {StateService} from '@uirouter/core';

import {LocalNetworkProfile} from '../../components/session/local-network-profile';
import {LocalUserPermissions} from '../../components/session/local-user-permissions';
import {LocalUserProfile} from '../../components/session/local-user-profile';
import {WorkspaceRegistryService} from '../../components/workspace-registry.service';
import {DataViewApiService} from '../common/controller/data-view-api.service';

export class FeatureStateDependencies {
  constructor(private readonly injector: Injector) {
  }

  localUserProfile(): LocalUserProfile {
    return this.injector.get(LocalUserProfile);
  }

  localUserPermissions(): LocalUserPermissions {
    return this.injector.get(LocalUserPermissions);
  }

  localNetworkProfile(): LocalNetworkProfile {
    return this.injector.get(LocalNetworkProfile);
  }

  dataViewApi(): DataViewApiService {
    return this.injector.get(DataViewApiService);
  }

  workspaceRegistry(): WorkspaceRegistryService {
    return this.injector.get(WorkspaceRegistryService);
  }

  state(): StateService {
    return this.injector.get(StateService);
  }

  service<T>(token: Type<T>): T {
    return this.injector.get(token);
  }

}
